import React, { useContext, useState } from "react"
import { Grid, Box, Card, IconButton, Divider, CardHeader, Typography, Hidden, Drawer, useMediaQuery, Alert } from "@mui/material"
import { makeStyles } from "@mui/styles";

import __t from "../../../lib/traduzioni"
import BSSPreventivoContext from "../../../contexts/BSSPreventivoContext";
import BSSSwitch from "../../form/BSSSwitch";
import useBSSLogger from "../../../hooks/useBSSLogger";
import { ArrowLeft, ArrowRight, Close, ExpandLess, ExpandMore, FilterList } from "@mui/icons-material";
import BSSDrawer from "../../form/BSSDrawer";
import { useTheme } from "@emotion/react";
import { useRef } from "react";

const {logger} = useBSSLogger()


const FrammentoFiltri = ({methods, classes, aggiornaPreventivoStorage, onSubmit, clauses, setClauses, inPortal = false}) => {


    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"))

    /**
     * @type {{preventivi: ResCalculateType}}
     */
    const {preventivi} = useContext(BSSPreventivoContext);

    const [espandiFiltri, setEspandiFiltri] = useState(false);
    


    const listaPreventivi = preventivi?.quotations ?? [];

    
    const { 
        listaCategorieAddizionali = [] 
    } = preventivi ?? {};

    
    
    const npreventivi = listaPreventivi.length;

    const mostraStampanteNonRichiesta = listaPreventivi.reduce((esito, preventivo) => {
        return esito || !preventivo.printerrequired;
    }, false) 


    const printerRequiredProps = {
        name:"filtri.printerrequired", 
        label: __t("stampantenonrichiesta"),
        methods,
        SwitchProps: {
            afterChange: (v) => setClauses(
                {
                    ...clauses, 
                    filter: {
                        ...clauses.filter,
                        printernotrequired: methods.getValues("filtri.printerrequired")
                    }
                }
            )
        }
    }


    
    logger.debug("props da passare al campo mostra solo senza stampante", printerRequiredProps);

    const filtriProps = {
        mostraStampanteNonRichiesta, 
        classes, 
        printerRequiredProps, 
        listaCategorieAddizionali, 
        methods, 
        clauses,
        setClauses,
        inPortal
    };

    return (
            <Card >
                <Box display={"flex"}>
                    <Box flexGrow={1}>
                        <Grid style={{ display: "flex" }}>
                            <FilterList />
                            <Typography>{__t("filtri")}</Typography>
                        </Grid>                            
                    </Box>
                    <Box>
                        {!isDesktop && (
                            <IconButton  size="small" color="primary" onClick={e => setEspandiFiltri(!espandiFiltri)}>
                                {!espandiFiltri ? <ArrowRight /> : <ArrowLeft />}
                            </IconButton>
                        )}
                    </Box>
                </Box>
                        

                <Divider />
                
                {isDesktop && (
                    <Filtri {...filtriProps} />
                )}
                    
                {!isDesktop && (
                    <BSSDrawer open={espandiFiltri} onClose={e => setEspandiFiltri(false)}  >

                        <Grid style={{ display: "flex" }}>
                            <FilterList />
                            <Typography>{__t("filtri")}</Typography>
                        </Grid>                            
                        
                        <IconButton  size="small" color="primary" onClick={e => {
                            logger.debug("click chiusura drawer filtri")
                            setEspandiFiltri(false)}
                        }>
                            <Close />
                        </IconButton>

                        
                        <Divider />

                        <Filtri {...filtriProps} />

                    </BSSDrawer> 
                )}
                
            </Card>
    
    )
}

const Filtri = ({mostraStampanteNonRichiesta, classes, printerRequiredProps, listaCategorieAddizionali, methods, clauses, setClauses, inPortal = false}) => {

    const filtriRef = useRef(null);

    const categorieNonSpeciali = listaCategorieAddizionali
        .filter(categoria => !categoria.categspeciale) 

    const contaFiltri = categorieNonSpeciali.reduce((n, c) => n + 1, (mostraStampanteNonRichiesta ? 1 : 0));

    return (
        <section ref={filtriRef}>

            {/* <pre>{JSON.stringify(clauses.filter, null, 2)}</pre> */}
            {(contaFiltri < 1) && (
                <Alert severity="info" >
                    {__t("nessunfiltrodisp")}
                </Alert>
            )}

            {mostraStampanteNonRichiesta && (
                <>
                    <Grid item xs={12} className={classes.formGroupBox}>
                        <Box width={1} pl={inPortal ? 2 : 0}
                            mb={{xs: "0.2em", sm: "0.2em", md: "0.2em"}} >                        
                                <BSSSwitch {...printerRequiredProps} />                                                        
                        </Box>
                    </Grid>
                
                </>
            )}

            {
                categorieNonSpeciali
                    .map((categoria) => {

                    const fieldName = `filtri.categorieAddizionali.${categoria.id}`


                    return (
                        <Grid item xs={12} className={classes.formGroupBox} key={categoria.id}>
                            <Box width={1}  pl={inPortal ? 2 : 0}
                                mb={{xs: "0.5em", sm: "0.5em", md: "0.5em"}} >
                                    
                                    <BSSSwitch {...{
                                        name: fieldName,
                                        label: spedizioniweb2.ucfirst((categoria?.multiDescr?.testo ?? "").toLowerCase()),
                                        methods,
                                        SwitchProps: {
                                            afterChange: v => {
                        
                                                const valore = methods.getValues(fieldName);
                                                const oldFilter = clauses.filter;
                                                const newFilter = {
                                                    ...clauses, 
                                                    filter: {
                                                        ...clauses.filter,
                                                        [fieldName]: valore
                                                    }                                                        
                                                };

                                                logger.debug("cambiato valore per il filtro", fieldName, valore, v, "aggiorno le filter clause", oldFilter, newFilter.filter)

                                                setClauses(newFilter)
                                            }
                                        }
                                        
                                    }} />         
                            </Box>
                        </Grid>
                    )
                }) 
            }
        </section>
    )
}

export default FrammentoFiltri